import React, { useMemo } from 'react'
import { Grid, Typography } from '@mui/material'
import { BasicInput } from '_/components/inputs'
import { useSelector } from 'react-redux'
import { useParams } from '@reach/router'

import useStyles from '../styles'
import { useFormContext } from 'react-hook-form'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'
import { getBudgetByIdSelectorJS } from '_/modules/budget/selectors'
import { currentServiceOrderSelector } from '_modules/service-orders/selectors'

const NAME = 'warrantyMonths'

export function WarrantyMonthsField() {
  const styles = useStyles()
  const { watch } = useFormContext()
  const { addProblemReadOnly } = useBudgetForm()
  const { budgetId } = useParams()

  const budget = useSelector(getBudgetByIdSelectorJS(budgetId))
  const serviceOrder = useSelector(currentServiceOrderSelector)
  const watchedName = watch(NAME)

  const defaultWarrantyValue = useMemo(() => {
    if (!watchedName && budget?.proposeOpened && !serviceOrder?.tradesman) {
      return 3
    }

    return watchedName
  }, [watchedName, budget, serviceOrder])

  return (
    <Grid className={styles.warrantyField}>
      <BasicInput
        required
        defaultValue={defaultWarrantyValue}
        placeholder=""
        name={NAME}
        labelClasses={styles.label}
        style={{ marginTop: '18px' }}
        label="Garantia deste serviço"
        rules={{ maxLength: { value: 2, message: 'Selecione entre 0 e 12 meses' } }}
        inputSx={{ width: '28px', '& .MuiInputBase-input': { textAlign: 'center' } }}
        disabled={addProblemReadOnly}
      />
      <Typography className={styles.warrantyText}>mês(es)</Typography>
    </Grid>
  )
}
